import GetIntouchCard from "./GetIntouchCard";

const getInTouchData = [
  {
    heading: "Sales",
    content:
      "Interested in learning more about the VENSAP platform? Book a customized demo with our sales team.",
  },
  {
    heading: "Partnerships",
    content:
      "Get in touch to learn about joining our trusted partner ecosystem for mutually beneficial opportunities.",
  },
  {
    heading: "Marketing & Media",
    content:
      "Have a marketing, media, PR, or analyst inquiry? Get in touch with our marketing team to learn more.",
  },
  {
    heading: "Customer Support",
    content: "Find the answers to your questions on our Knowledge Base.",
  },
  {
    heading: "Mailing Address",
    content: "contact.vensap@gmail.com",
  },
];
const GetInToTouch = () => {
  return (
    <>
      <div className="getintotouch">
        <div className="heading">
          <p className="text-center">We’re Here to Help</p>
          <p className="product-title">Get in touch</p>
        </div>
        <div className="getintouchcard">
          <GetIntouchCard getInTouchData={getInTouchData} />
        </div>
      </div>
    </>
  );
};
export default GetInToTouch;
